import { createAction } from 'redux-actions';

export const userCarReview = createAction('USER_DASHBOARD_USER_CAR_REVIEW');
export const userCarReviewSuccess = createAction('USER_DASHBOARD_USER_CAR_REVIEW_SUCCESS');
export const userCarReviewError = createAction('USER_DASHBOARD_USER_CAR_REVIEW_ERROR');
